import React, { useState } from "react";
import PropTypes from "prop-types";
import { Text, Box, Flex } from "rebass";
import { MetricFormForWeight, ImperialFormForWeight } from "./form";
import Switch from "../../Components/Switch";
import { UnitConverter } from "@sisuwellness/utilities";

const UNITS = {
    imperial: "Imperial",
    metric: "Metric"
};

const HRAWeight = ({ model, setErrors, onSubmit, value }) => {
    const [isUnitMetric, setIsUnitMetric] = useState(true);

    const handleToggle = selectedMetric => setIsUnitMetric(selectedMetric === UNITS.metric);

    const handleSubmit = values => {
        let value;
        if (isUnitMetric) value = values.weightInKg;
        else value = convertImperialToMetric(values.weightInSt, values.weightInLbs);
        onSubmit(`${value}`);
    };

    const convertImperialToMetric = (stones, pounds) => {
        return UnitConverter.stLbsToKg(Number(stones), pounds ? Number(pounds) : 0).toFixed(1);
    };

    const convertMetricToImperial = value => {
        if (!value) return ["", ""];
        const { stones, pounds } = UnitConverter.kgToStLbs(value);
        return [stones, pounds.toFixed(1)];
    };

    return (
        <Flex justifyContent="center" flexDirection="column" alignItems="flex-start">
            <Text fontSize={["22px", "34px"]} textAlign="left" fontWeight="500">
                What is your {model.getDisplayText().toLowerCase()} {model.getHelpText()}
            </Text>
            <Flex justifyContent="space-between" alignItems="center" mt={["17px", "0px"]} width="100%">
                <Text textAlign="left" fontSize={["13px", "15px"]}>
                    Choose your system of measurement:
                </Text>
                <Switch first={UNITS.metric} second={UNITS.imperial} onToggle={handleToggle} />
            </Flex>
            <Box mt="32px" />
            {isUnitMetric ? (
                <MetricFormForWeight
                    onSubmit={handleSubmit}
                    {...{ setErrors, value }}
                    isRequired={model.isRequired()}
                />
            ) : (
                <ImperialFormForWeight
                    onSubmit={handleSubmit}
                    {...{ setErrors }}
                    isRequired={model.isRequired()}
                    value={convertMetricToImperial(value)}
                />
            )}
        </Flex>
    );
};

HRAWeight.propTypes = {
    model: PropTypes.shape({
        getHelpText: PropTypes.func,
        getDisplayText: PropTypes.func,
        isRequired: PropTypes.func
    }),
    setErrors: PropTypes.func,
    onSubmit: PropTypes.func,
    value: PropTypes.any
};

export default HRAWeight;
